import joditValidate from 'helpers/validates/jodit'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const richTextRequired = {
  name: 'richTextRequired',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'Preencha esse campo') {
    return this.required(message).test(
      'hasContent',
      message,
      joditValidate.hasContent,
    )
  },
}

export default richTextRequired
